import { styled } from '@linaria/react';

function EarlyButton({ children }) {
  return <Wrapper>{children}</Wrapper>;
}

const Wrapper = styled.button`
  width: 100px;
  height: 100px;
  border-radius: 50%;
  border: none;
  background: hsl(345deg, 100%, 47%);
  color: white;
  font-size: 20px;
  font-weight: 500;
  line-height: 1;
  text-align: center;
  transition: transform 250ms;
  will-change: transform;

  &:hover {
    transform: translateY(-10px);
  }
`;

export default EarlyButton;
